import React from 'react'
import Link from '../utils/link'
import parse from 'html-react-parser'

const Projects = ({ items }) => {

  return (
    <section className='projects'>
      <div className='projects__inner'>
        { items?.length > 0 &&
          <div className='projects__items'>
            { items.map((item, index) => (
              <div className='projects__item' key={index}>
                { item.image && <img className='projects__image' src={item.image.sourceUrl} alt={item.name} /> }
                <div className='projects__rollover'>
                  <h3 className='projects__title'>{item.name}</h3>
                  <div className='projects__description'>
                    <ul>
                      { item.address && <li><strong>Address</strong><br />{parse(item.address)}</li> }
                      { item.developer && <li><strong>Developer</strong><br />{item.developer}</li> }
                      { item.architect && <li><strong>Architect</strong><br />{item.architect}</li> }
                      { item.builder && <li><strong>Builder</strong><br />{item.builder}</li> }
                      { item.link && <li><Link to={item.link}>View Project</Link></li> }
                    </ul>
                  </div>
                </div>
                <Link className='projects__link' to={item.link} />
              </div>
            ))}
          </div>
        }
      </div>
    </section>
  )

}

export default Projects